var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.192 18.947h-5.845a.766.766 0 0 1-.764-.764v-3.63A1.63 1.63 0 0 0 9.94 12.91a1.63 1.63 0 0 0-1.643 1.643v3.63c0 .42-.344.764-.764.764H1.764A.766.766 0 0 1 1 18.183v-9.78c0-.688.344-1.338.879-1.72l7.679-5.54a.745.745 0 0 1 .879 0l7.679 5.54c.535.382.879 1.032.879 1.72v9.818a.824.824 0 0 1-.803.726zm-5.08-1.49h4.354V8.402a.653.653 0 0 0-.267-.496L9.979 2.67 2.756 7.867a.653.653 0 0 0-.267.497v9.055h4.355v-2.866a3.147 3.147 0 0 1 3.133-3.133 3.147 3.147 0 0 1 3.133 3.133v2.904z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f37c86944633d438e4f886adcec523b4.svg";
export { ForwardRef as ReactComponent };